var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21.836,
    height: 17.006,
    viewBox: "0 0 21.836 17.006",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1213b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a6192e"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "car-fill-svgrepo-com",
    d: "M1.489,23.268H2.577a1.194,1.194,0,0,0,1.218-1.2v-1.54c2.048.128,5.009.22,7.38.22s5.341-.092,7.389-.22v1.54a1.188,1.188,0,0,0,1.218,1.2h1.089a1.2,1.2,0,0,0,1.227-1.2v-5.29a4.966,4.966,0,0,0-1.172-3.511l-.775-1a21.57,21.57,0,0,0-1.273-4.061A3.28,3.28,0,0,0,16.2,6.39c-.618-.073-2.638-.128-5.028-.128s-4.4.064-5.018.128A3.243,3.243,0,0,0,3.481,8.205a21.568,21.568,0,0,0-1.273,4.061l-.775,1A4.967,4.967,0,0,0,.262,16.777v5.29A1.2,1.2,0,0,0,1.489,23.268ZM4.072,11.506A12.929,12.929,0,0,1,5.04,8.654a1.2,1.2,0,0,1,1.015-.678,47.474,47.474,0,0,1,5.12-.156,42.86,42.86,0,0,1,5.129.156,1.247,1.247,0,0,1,1.015.678,13.235,13.235,0,0,1,.969,2.851c.083.339-.055.468-.415.44-1.531-.092-3.358-.192-6.7-.192s-5.157.1-6.688.192C4.127,11.973,4,11.845,4.072,11.506Zm.378,6.867a1.522,1.522,0,1,1,0-3.044,1.522,1.522,0,1,1,0,3.044Zm13.459,0a1.522,1.522,0,1,1,1.531-1.522A1.495,1.495,0,0,1,17.909,18.372ZM8.73,17.95a1.1,1.1,0,0,1,0-2.2h4.9a1.1,1.1,0,0,1,0,2.2Z",
    transform: "translate(-0.262 -6.262)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.43581afff3f1b31d2f5d449264ee9a0d.svg";
export { ForwardRef as ReactComponent };